import { DropdownFieldUI } from '@axo/form/feature/form-input/DropdownField/DropdownFieldUI';
import { NumberFieldUI } from '@axo/form/feature/form-input/NumberField/NumberFieldUI';
import { Education } from '@axo/shared/data-access/types';
import { useTranslation } from '@axo/shared/i18n';
import { Grid } from '@axo/ui-core/components/layout/item';
import { useWatch } from 'react-hook-form';
import { formatSpacedNumber } from '../../../../../../utils/format';
import type { EducationFormGroupData } from '../../../../FormData.fi.types';
import { educationOptions } from '../../../config/globals';
import { gridColumns } from '../../../config/layouts/grid';
import styles from '../../../loan.module.scss';
import {
  educationFieldOption,
  studentDebtMonthlyDebtPaymentFieldOption,
  studentDebtOutstandingAmountFieldOption,
} from './config';

export function EducationFormGroup() {
  const { t } = useTranslation();

  const education = useWatch({ name: 'LoanApplication/Education' });
  const studentOutstandingAmount = useWatch({
    name: 'Debt/Student/OutstandingAmount',
  });

  const askStudentDebt = [Education.EducationHigherEducation].includes(
    education
  );

  const askMonthlyPayment = Number(studentOutstandingAmount) > 0;

  return (
    <>
      <Grid columns={gridColumns}>
        <DropdownFieldUI<EducationFormGroupData>
          name="LoanApplication/Education"
          label={t('Education.label')}
          data-testid="education-input"
          options={educationOptions}
          {...educationFieldOption}
        />
      </Grid>

      {askStudentDebt && (
        <div className={styles.inputGroup} data-grey={true}>
          <Grid columns={gridColumns}>
            <NumberFieldUI<EducationFormGroupData>
              name="Debt/Student/OutstandingAmount"
              label={t('Debt.Student.OutstandingAmount.label')}
              data-testid="debt-student-outstanding-amount-input"
              format={formatSpacedNumber}
              suffix={t('suffix.currency')}
              {...studentDebtOutstandingAmountFieldOption}
            />

            {askMonthlyPayment && (
              <NumberFieldUI<EducationFormGroupData>
                name="Debt/Student/MonthlyDebtPayment"
                label={t('Debt.Student.MonthlyDebtPayment.label')}
                data-testid="debt-student-monthly-debt-payment-input"
                format={formatSpacedNumber}
                suffix={t('suffix.currency')}
                {...studentDebtMonthlyDebtPaymentFieldOption}
              />
            )}
          </Grid>
        </div>
      )}
    </>
  );
}
